export const getDomain = () => {
  if (process.env.NODE_ENV === "production") {
    return `https://apidesk.levelpropiedades.cl`;
  }
  return `https://apidesk.levelpropiedades.cl`;
};

export const getMenuListURL = (rol, usuario) => {
  if (process.env.NODE_ENV === "production") {
    return `/api/menu?rol=${rol}&usuario=${usuario}`;
  }
  return `/api/menu?rol=${rol}&usuario=${usuario}`;
};

export default getDomain;
